var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#D04242",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2898 15.0879L14.5108 13.2971L16.2888 11.5064C16.6308 11.163 16.6308 10.604 16.2888 10.2606C15.9468 9.91414 15.3938 9.91515 15.0518 10.2596L13.2728 12.0503L11.4938 10.2576C11.1518 9.91313 10.5978 9.91515 10.2558 10.2576C9.91475 10.602 9.91475 11.161 10.2558 11.5044L12.0358 13.2971L10.2598 15.0848C9.91775 15.4293 9.91775 15.9882 10.2598 16.3307C10.4308 16.5039 10.6538 16.5895 10.8778 16.5895C11.1028 16.5895 11.3258 16.5039 11.4968 16.3317L13.2728 14.543L15.0528 16.3347C15.2238 16.5069 15.4468 16.5925 15.6708 16.5925C15.8948 16.5925 16.1188 16.5059 16.2898 16.3347C16.6318 15.9903 16.6318 15.4323 16.2898 15.0879Z",
    fill: "#D04242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.1cd00f6229171dec0bebfeb9ebc18cb5.svg";
export { ForwardRef as ReactComponent };